/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformAddFeedbackComment } from '../../models/platform-add-feedback-comment';
import { PlatformApiResultOfFeedbackDetailDto } from '../../models/platform-api-result-of-feedback-detail-dto';

export interface PostFeedbackManageActionComment$Params {
      body: PlatformAddFeedbackComment
}

export function postFeedbackManageActionComment(http: HttpClient, rootUrl: string, params: PostFeedbackManageActionComment$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>> {
  const rb = new RequestBuilder(rootUrl, postFeedbackManageActionComment.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfFeedbackDetailDto>;
    })
  );
}

postFeedbackManageActionComment.PATH = '/api/feedback/manage/action/comment';
